import React from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";

const AboutSamsung = (props, context) => {
  return (
    <Row className="d-flex justify-content-between bigger-margin-top py-5">
      <Col xs={12} md={4} className="py-md-5">
        <p className="fs-5">{context.t("Two brands one vision")}</p>
        <h2 className="text-white mb-5 h1">{context.t("Samsung x Ledger")}</h2>
      </Col>
      <Col
        xs={12}
        md={6}
        className="align-items-center align-self-center my-0 my-lg-5"
      >
        <p>
          {context.t(
            "Maximum security and the most important basic knowledge for the step into Web3."
          )}
        </p>
        <p style={{ whiteSpace: "pre-wrap" }}>
          {context.t(
            "Samsung opens the gates to Web3. Be the first to join the Samsung community and embark on a journey to a new world. \nFirst step to provide a Web3 Starter Bundle with Ledger on the Amazon marketplace. In addition to an onboarding experience by Ledger, the exclusive bundle also includes various NFTs designed by international and German artists from the NFT scene with an exciting minting experience over two phases."
          )}
        </p>
      </Col>
    </Row>
  );
};

/**  define proptype for the 'translation' function  */
AboutSamsung.contextTypes = {
  t: PropTypes.func,
};

AboutSamsung.propTypes = {};

AboutSamsung.defaultProps = {};

export default AboutSamsung;
